import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[clickOutside]' // eslint-disable-line
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter<MouseEvent | void>();

  constructor(
    private elementRef: ElementRef,
  ) { }

  @HostListener('document:click', ['$event'])
  public onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.clickOutside.emit(event);
    }
  }

}
